import { Stack } from "@mui/material";
import { type ClipboardScoreLog } from "@src/appV2/ClipboardScore/api/useGetClipboardScoreHistory";
import { TimelinessAdjustmentInfoAlert } from "@src/appV2/redesign/ClipboardScore/components/TimelinessAdjustmentInfoAlert";
import { compareAsc, format, parseISO } from "date-fns";
import { groupBy } from "lodash";
import { useState } from "react";

import { ClipboardScoreHistorySection } from "./Section";

interface ClipboardScoreHistoryContentProps {
  logs: ClipboardScoreLog[];
  isDynamicPenaltiesEnabled: boolean;
  useExpectedArrivalTime: boolean;
}

export function ClipboardScoreHistoryContent({
  logs,
  isDynamicPenaltiesEnabled,
  useExpectedArrivalTime,
}: ClipboardScoreHistoryContentProps) {
  const groupedByDate = groupBy(logs, ({ createdAt }) => format(new Date(createdAt), "yyyy-MM-dd"));
  const sortedGroupedByDate = Object.entries(groupedByDate).sort((a, b) =>
    compareAsc(parseISO(b[0]), parseISO(a[0]))
  );

  const [expandedRow, setExpandedRow] = useState<string | false>(false);

  const onClick = (id: string, isExpanded: boolean) => {
    setExpandedRow(isExpanded ? false : id);
  };

  return (
    <Stack
      direction="column"
      spacing={8}
      sx={{
        paddingY: 3,
      }}
    >
      <TimelinessAdjustmentInfoAlert />
      {sortedGroupedByDate.map(([date, logs]) => {
        return (
          <ClipboardScoreHistorySection
            key={`history-section-${date}`}
            date={date}
            logs={logs}
            isDynamicPenaltiesEnabled={isDynamicPenaltiesEnabled}
            useExpectedArrivalTime={useExpectedArrivalTime}
            expandedRow={expandedRow}
            onClick={onClick}
          />
        );
      })}
    </Stack>
  );
}
